module.exports = __webpack_public_path__ + "img/Inspection.9d9beaa1.png";